import { AuditItem, BarcodeQty } from "@deliverr/crossdock-service-client";

export const formatAuditUpdateRequest = (auditItems: AuditItem[]): BarcodeQty[] =>
  auditItems.map((item) => ({
    barcode: item.barcode,
    qty: item.qty,
  }));
